import { createStore } from 'vuex';

export default createStore({
  state: {
    token: localStorage.getItem('token'),
  },
  getters: {
    hasLogin(state) {
      return !!state.token;
    },
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    }
  },
  actions: {
    
  },
  modules: {
  }
})
